import { decodeHTML } from 'entities'

export const entityDecode = (v) => {
  return decodeHTML(v)
}
